// fd.config.js - projectwide configuration file
module.exports = {
  roomTypes: [
    {
      id: "office",
      imgSrc: "img/office.svg",
      defaultLux: 500,
      params: {
        reflectance_wall: 0.5,
        reflectance_ceiling: 0.7,
        reflectance_floor: 0.2,
        maintenance_factor: 0.8,
        workplane_height: 0.75,
        required_lux_delta: 10,
        photometric_center_height: 2.5,
        photometric_center_height_delta: 0.25
      }
    },
    {
      id: "office2",
      imgSrc: "img/office2.svg",
      defaultLux: 300,
      params: {
        reflectance_wall: 0.5,
        reflectance_ceiling: 0.7,
        reflectance_floor: 0.2,
        maintenance_factor: 0.8,
        workplane_height: 0.75,
        required_lux_delta: 10,
        photometric_center_height: 2.5,
        photometric_center_height_delta: 0.25
      }
    },
    {
      id: "private",
      imgSrc: "img/living.svg",
      defaultLux: 300,
      params: {
        reflectance_wall: 0.5,
        reflectance_ceiling: 0.7,
        reflectance_floor: 0.2,
        maintenance_factor: 0.8,
        workplane_height: 0.75,
        required_lux_delta: 10,
        photometric_center_height: 2.5,
        photometric_center_height_delta: 0.25
      }
    },
    {
      id: "storage",
      imgSrc: "img/storage.svg",
      defaultLux: 100,
      params: {
        reflectance_wall: 0.5,
        reflectance_ceiling: 0.7,
        reflectance_floor: 0.2,
        maintenance_factor: 0.8,
        workplane_height: 0.75,
        required_lux_delta: 10,
        photometric_center_height: 2.5,
        photometric_center_height_delta: 0.25
      }
    },
    {
      id: "garage",
      imgSrc: "img/stairs.svg",
      defaultLux: 100,
      params: {
        reflectance_wall: 0.5,
        reflectance_ceiling: 0.7,
        reflectance_floor: 0.2,
        maintenance_factor: 0.8,
        workplane_height: 0,
        required_lux_delta: 10,
        photometric_center_height: 2.5,
        photometric_center_height_delta: 0.25
      }
    }
  ],
  scrollToResultDuration: 1000,
  maxResultListCount: 20
};
